import { styled } from '@teko/ui';
import React from 'react';
import { ProductVariant } from './ProductVariant/ProductVariant.es.js';

const Wrapper = styled.div`
  display: flex;
`;
const VariantWrapper = styled.div`
  margin-left: 8px;
  display: flex;
  flex-flow: wrap;
  max-width: calc(100% - 64px);
`;
const SelectedVariant = styled.div`
  font-size: 0/75rem;
  color: #848788;
  margin-top: 8px;
  text-transform: capitalize;
`;
const ProductVariants = ({
  configuration,
  onSelectVariant,
  index,
  className
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    className
  }, /* @__PURE__ */ React.createElement(SelectedVariant, null, configuration.name), /* @__PURE__ */ React.createElement(VariantWrapper, null, configuration.options.map((variant) => /* @__PURE__ */ React.createElement(ProductVariant, {
    key: variant.optionId,
    option: variant,
    onSelectVariant,
    type: configuration.optionType,
    index
  }))));
};

export { ProductVariants };
